import React from 'react';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import {
    Breadcrumb as AntBreadcrumb,
    BreadcrumbProps as AntBreadcrumbProps,
} from 'antd';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import Styles from './Breadcrumb.module.less';
import { classes } from '../../lib/strings';

type BreadcrumbProps = AntBreadcrumbProps & {
    children?: React.ReactNode;
    noBreak?: boolean;
};

const Breadcrumb = ({
    separator = <FontAwesomeIcon icon={faChevronRight} />,
    className,
    ...props
}: BreadcrumbProps): JSX.Element => (
    <AntBreadcrumb
        className={classes(className, Styles.aldBreadcrumb)}
        separator={separator}
        {...props}
    />
);

Breadcrumb.Item = AntBreadcrumb.Item;
Breadcrumb.Separator = AntBreadcrumb.Separator;

export { Breadcrumb };
export type { BreadcrumbProps };
